import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  EventEmitter,
  Output,
} from "@angular/core";

interface ValidationError {
  column: string;
  validation_message: string;
  level: string;
  recommended_action: string;
}

interface ErrorResponse {
  [key: string]: ValidationError[];
}

interface ErrorCategory {
  category: string;
  validationType: string;
  errors: ValidationError[];
  warnings: ValidationError[];
  totalWarnings: number;
  totalErrors: number;
  show?: boolean;
}

@Component({
  selector: "app-file-validation",
  templateUrl: "./file-validation.component.html",
  styleUrls: ["./file-validation.component.scss"],
})
export class FileValidationComponent implements OnInit, OnChanges {
  errorCount = 0;
  errorCountLabel = "";
  allErrors: ErrorCategory[] = [];

  @Input() errorResponse: ErrorResponse | undefined;
  @Input() editModifyFlag: boolean = true;
  @Input() isValidationSuccess: boolean = false;
  uploadStatus: boolean = false;
  @Input() fileUploadContent: any;
  @Output() actionErrorEmitCall = new EventEmitter<any>();

  ngOnInit() {
    this.processErrors();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.errorResponse?.currentValue) {
      this.processErrors();
      this.uploadStatus = this.fileUploadContent?.fileUploadStatus;
    }
  }

  processErrors() {
    if (!this.errorResponse) {
      return;
    }

    const errorCategories = Object.keys(this.errorResponse) as string[];
    this.allErrors = [];
    errorCategories.forEach((category) => {
      if (category === "merge_conflicts") {
        this.setMergeConflictsError(category);
        return;
      }
      const errors = this.errorResponse![category] || [];
      if (errors.length && errors.length > 0 && Array.isArray(errors)) {
        const warnings = errors?.filter((error) => error.level === "amber");
        const criticalErrors = errors?.filter((error) => error.level === "red");
        const totalWarnings = warnings.length;
        const totalErrors = criticalErrors.length;
        const validationType = this.formatCategoryName(category);
        this.allErrors.push({
          category,
          errors: criticalErrors,
          warnings,
          validationType,
          totalErrors,
          totalWarnings,
          show: true,
        });
      }
    });
    this.allErrors.sort((a, b) => b.totalErrors - a.totalErrors);
  }

  formatCategoryName(category: string): string {
    return category
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }

  openDescription(errorCategory: any) {
    errorCategory.show = !errorCategory.show;
  }

  isValidationDataEmpty(): boolean {
    return (
      !this.errorResponse ||
      Object.keys(this.errorResponse).length === 0 ||
      this.allErrors.length === 0
    );
  }

  // Helper method to set the error for merge conflicts
  setMergeConflictsError(category: string) {
    const warnings: any = [];
    const criticalErrors = [
      {
        column: category,
        level: "red",
        validation_message: "Merge conflicts found.",
        recommended_action: "Please click and resolve the merge conflicts",
      },
    ];
    const totalWarnings = 0;
    const totalErrors = 1;

    const validationType = this.formatCategoryName(category);
    this.allErrors.push({
      category,
      errors: criticalErrors,
      warnings,
      validationType,
      totalErrors,
      totalWarnings,
      show: true,
    });
  }

  // Helper method to check the key is Array or not
  checkArrayOrNot(value: any): boolean {
    return Array.isArray(value);
  }

  // Helper method to get the formated column value
  getFormattedColumn(error: any) {
    return this.checkArrayOrNot(error?.column) ? error.column.join(", ") : "";
  }
}
